/**
 * Kraftstoffkosten-Richtwerte & Berechnung — mit Kraftstoffart-Auswahl.
 * Live-Preise kommen aus /api/fuel-prices/current (Tankerkönig), sonst Fallback-Richtwerte.
 */

export const FUEL_TYPES = {
  petrol: { key: 'petrol', label: 'Benzin', unit: 'L', per100: 8, fallbackPrice: 2.09, savings: 0.4, priceKey: 'e10', pumpLabel: 'An der Säule' },
  diesel: { key: 'diesel', label: 'Diesel', unit: 'L', per100: 6.5, fallbackPrice: 1.98, savings: 0.4, priceKey: 'diesel', pumpLabel: 'An der Säule' },
  electric: { key: 'electric', label: 'Elektro', unit: 'kWh', per100: 18, fallbackPrice: 0.45, savings: 0.27, priceKey: 'electric_kwh', pumpLabel: 'An der Ladesäule' },
};

// Legacy-Konstanten (weiterhin exportiert)
export const FUEL_LITERS_PER_100KM = 8;
export const FUEL_EURO_PER_LITER = 1.85;
export const FUELX_SAVINGS_PER_LITER = 0.4;

/**
 * @param {{ vehicleCount?: number, annualKm?: number, fuelType?: string, pricePerUnit?: number|null }} params
 */
export function computeAnnualFuelCost({ vehicleCount = 1, annualKm = 15000, fuelType = 'petrol', pricePerUnit = null } = {}) {
  const ft = FUEL_TYPES[fuelType] || FUEL_TYPES.petrol;
  const price = pricePerUnit != null ? pricePerUnit : ft.fallbackPrice;
  const unitsPerVehicle = (annualKm * ft.per100) / 100;
  const perVehicleEur = unitsPerVehicle * price;
  const totalEur = perVehicleEur * vehicleCount;
  const monthlyEur = totalEur / 12;
  const units = unitsPerVehicle * vehicleCount;
  const effectivePrice = Math.max(price - ft.savings, 0);
  const savingsPerYearEur = units * ft.savings;
  return { totalEur, perVehicleEur, monthlyEur, units, vehicleCount, price, effectivePrice, savingsPerYearEur, fuelType: ft.key };
}

export function formatEurRounded(value) {
  return `${Math.round(value).toLocaleString('de-DE')} €`;
}

export function formatEurPerLiter() {
  return FUEL_EURO_PER_LITER.toFixed(2).replace('.', ',');
}
